export default (axios, path = '/game/lobby') => ({
  findLobbyDataById: async (id) => {
    return await axios.get(`${path}/${id}`)
  },
  findByCodeAndJoin: async (code) => {
    return await axios.get(`${path}/join/code/${code}`)
  },
  findByIdAndJoin: async (id) => {
    return await axios.get(`${path}/join/${id}`)
  },
  // Only for 
  removeUserFromLobby: async (userId) => {
    return await axios.put(`${path}/remove/${userId}`)
  },
  addCurrentUserToTeam: async (teamId) => {
    return await axios.put(`${path}/team/join/${teamId}`)
  },
  removeUserFromTeam: async (userId) => {
    const args = userId ? {userId} : {}
    return await axios.put(`${path}/team/remove`, args)
  },
})
